import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ToolModelFromProducerSelectorViewModel extends SelectorBaseViewModel<ToolModelFromProducer> {
    constructor(parentViewModel: ViewModel, id: string = null) {
        super(parentViewModel, true);
        this.toolModelId = id;
    }

    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;

    protected async loadData(): Promise<ToolModelFromProducer[]> {
        if (this.toolModelId != null) {
            let result = await ServerConnection.callServer('/Complex/ToolModelFromProducerServices/ListAllToolModelFromProducers', {
                ToolModelId: this.toolModelId
            });
            return result.ToolModelFromProducers.map(x => {
                let t = new ToolModelFromProducer(this);
                t.id = x.Id;
                t.title = `${x.ToolProducerName} (${x.ToolProducerCode})`;
                return t;
            });
        }
        return [];
    }
}

export class ToolModelFromProducer extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}